<template>
  <survey-send-invitations
    title="label_violenceSurvey_sendToStaff_title"
    background-color="#f5fafd"
    template-id="ViolenceSurvey"
    management-route="violence-survey"
  />
</template>
<script >
import SurveySendInvitations from "./SurveySendInvitations";
import { mapGetters } from "vuex";
export default {
  name: "ViolenceSurveySendInvitations",
  components: { SurveySendInvitations },
  computed: {
    ...mapGetters(["getCurrentSnapshot"]),
  },
  watch: {
    getCurrentSnapshot: {
      deep: true,
      handler() {
        this.checkAccess();
      },
    },
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      if (!this.getCurrentSnapshot.surveyViolenceStatus) {
        this.$router.push("/home");
      }
    },
  },
};
</script >
<style lang="sass" >
.modal
  text-align: center
  .modal-title
    width: 100%
</style >
